import { useEffect, useState } from "react";
import { requestNotificationPermission, isNotificationSupported } from "../services/firebase";
import { api } from "../api/client";

// Wrapper sobre o Firebase Cloud Messaging — gerencia permissão (granted/
// denied/default), token FCM atual e registro/remoção no backend.
//
// solicitarPermissao(): pede ao browser, registra o token em /push/registrar-token.
// remover(): chama /push/remover-token e limpa estado local.
// `suportado`: false em browsers sem Notification API ou em contextos não-HTTPS.
export const usePush = () => {
  const [permissao, setPermissao] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'default');
  const [token, setToken] = useState(null);
  const [suportado, setSuportado] = useState(false);

  useEffect(() => {
    setSuportado(isNotificationSupported());
  }, []);

  const solicitarPermissao = async () => {
    if (!suportado) return null;
    try {
      const fcmToken = await requestNotificationPermission();
      if (!fcmToken) {
        setPermissao(Notification.permission);
        return null;
      }
      setPermissao('granted');
      setToken(fcmToken);
      try {
        await api.post('/push/registrar-token', { fcm_token: fcmToken });
        console.log('[PUSH] Token FCM registrado no backend');
      } catch(e) { console.log('[PUSH] Backend indisponível, continuando sem push remoto'); }
      return fcmToken;
    } catch (err) { console.error('[PUSH] Erro ao solicitar permissão:', err); return null; }
  };

  const remover = async () => {
    if (token) {
      try {
        await api.fetch('/push/remover-token', { method: 'DELETE', body: JSON.stringify({ fcm_token: token }) });
      } catch(e) {}
      setToken(null);
    }
  };

  return { permissao, token, suportado, solicitarPermissao, remover };
};
